var Conversation = (function(Conversation) {

  function Sender(el) {
    this.el = $(el);
    this.initUploader();
    this.attachEvents();
  }

  Sender.prototype.initUploader = function() {
    this.attacherWidget = this.el.find('.cw-conversation-upload');
    this.attacher = this.el.find('.js-conversation-attachment');
    this.attachmentList = this.el.find('.js-conversation-attachments');
    if (this.attachmentList.children().length > 0) {
      this.attachedFile = new Conversation.Attachment(null, this, this.attachmentList.children().first());
    }
    this.attacher.on('change', this.uploadFile.bind(this));
  }

  Sender.prototype.attachEvents = function() {
    var form = this.el;

    form.on('submit', function(ev) {
      ev.preventDefault();
      var data = serializeForm(form);
      delete data.file; // Don't try to send the attached file

      var mustSend = false;
      var message_id;

      // If there's a message, send it
      if ($.trim(data['message[body]']) !== '') {
        message_id = Conversation.Thread.addMessage(data);

        // Clean up the form
        form[0].reset();

        mustSend = true
      }

      // If there's an attachment, render it
      if (this.attachedFile) {
        Conversation.Thread.addAttachment(this.attachedFile.fileMetadata);
        this.attachedFile.remove(false);
        this.attachedFile = undefined;
        mustSend = true
      }

      if (mustSend) {
        $.ajax({
          method: 'POST',
          url: form.attr('action'),
          data: data,
          dataType: 'json'
        }).done(function() {
          if (message_id) {
            Conversation.Thread.markAsSent(message_id);
          }
        });
      }

    }.bind(this));
  };

  Sender.prototype.disableUploader = function() {
    this.attacherWidget.addClass('disabled');
    this.attacher.prop('disabled', true);
  }

  Sender.prototype.enableUploader = function() {
    this.attacherWidget.removeClass('disabled');
    this.attacher.removeProp('disabled');
  }

  Sender.prototype.uploadFile = function(e) {
    var file = e.target.files[0];
    if (!file) {
      return;
    }

    this.attachedFile = new Conversation.Attachment(file, this);
    this.attachmentList.append(this.attachedFile.render());
    this.disableUploader();
  }


  // Stolen from http://stackoverflow.com/a/1186309/508684
  function serializeForm(form) {
    var o = {};
    $.each(form.serializeArray(), function() {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  }

  Conversation.Sender = Sender;
  return Conversation;

})(Conversation || {});
